var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"mid-content"},[_c('div',{staticClass:"desc"},[_vm._v("正在开通中......")])])])
}]

export { render, staticRenderFns }